import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { BankIDInputMeta, CorporateNameInputMeta } from "../../commonMeta";

export interface I_IssuerRiskMetaParametersFormMeta {
    bankID: FormInputMeta;
    corporateName: FormInputMeta;
    transactionCode: FormInputMeta; 
    mccGroup: FormInputMeta;
    transactionType: FormInputMeta;
    merchantCountry: FormInputMeta;
    paymentCanal: FormInputMeta;
    paymentScheme: FormInputMeta;
    cardUsage: FormInputMeta;
    binType: FormInputMeta;
    bankGroup: FormInputMeta;
    schema: any;
}

const issuerRiskManagementParametersFormMeta = {} as I_IssuerRiskMetaParametersFormMeta;

issuerRiskManagementParametersFormMeta.bankID = BankIDInputMeta;

issuerRiskManagementParametersFormMeta.corporateName = CorporateNameInputMeta;

issuerRiskManagementParametersFormMeta.transactionCode = {
  name: "transactionCode",
  type: "checkbox",
  label: "Transaction Code",
  placeholder: "",
  validation: yup.boolean().required("Transaction Code is required"),
};

issuerRiskManagementParametersFormMeta.mccGroup = {
    name: "mccGroup",
    label: "MCC Group",
    type: "checkbox",
    value: "",
    validation: yup.boolean().required("MCC Group is required"),
  };
  
  issuerRiskManagementParametersFormMeta.transactionType = {
    name: "transactionType",
    label: "Transaction Type",
    type: "checkbox",
    value: "",
    validation: yup.boolean().required("Transaction Type is required"),
  };
  
  issuerRiskManagementParametersFormMeta.merchantCountry = {
    name: "merchantCountry",
    label: "Merchant Country",
    type: "checkbox",
    value: "",
    validation: yup.boolean().required("Merchant Country is required"),
  };
  
  issuerRiskManagementParametersFormMeta.paymentCanal = {
    name: "paymentCanal",
    label: "Payment Canal",
    type: "checkbox",
    value: "",
    validation: yup.boolean().required("Payment Canal is required"),
  };
  
  issuerRiskManagementParametersFormMeta.paymentScheme = {
    name: "paymentScheme",
    label: "Payment Scheme",
    type: "checkbox",
    value: "",
    validation: yup.boolean().required("Payment Scheme is required"),
  };
  
  issuerRiskManagementParametersFormMeta.cardUsage = {
    name: "cardUsage",
    label: "Card Usage",
    type: "checkbox",
    value: "",
    validation: yup.boolean().required("Card Usage is required"),
  };
  
  issuerRiskManagementParametersFormMeta.binType = {
    name: "binType",
    label: "Bin Type",
    type: "checkbox",
    value: "",
    validation: yup.boolean().required("Bin Type is required"),
  };

  issuerRiskManagementParametersFormMeta.bankGroup = {
    name: "bankGroup",
    label: "Bank Group",
    type: "checkbox",
    value: "",
    validation: yup.boolean().required("Bank Group is required"),
  };

issuerRiskManagementParametersFormMeta.schema = yup.object().shape(getValidationSchema(issuerRiskManagementParametersFormMeta));

export default issuerRiskManagementParametersFormMeta;